















import { defineComponent, reactive } from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

import useDownloadReport from '@/useDownloadReport';

const NOW = useFormat.date().computerShortDate();

const VehicleMaintenanceCostReport = defineComponent({
  setup() {
    const { getCSVReport } = useDownloadReport();
    const filter = reactive({
      range: {
        from: undefined,
        to: undefined,
      },
    });

    return {
      filter,
      getCSVReport,
    };
  },
});

export default VehicleMaintenanceCostReport;
